// Pure helpers for #193 (task → lead_treatment auto-bind) and #174
// (SCHEDULE_REMINDER preset menu).
// Keeping these out of TaskSlideout.jsx so they're trivially unit-testable
// without dragging in MUI / Redux / Vite-only modules.

// "Active" = lead_treatment whose status is neither CLOSED nor ARCHIVED.
// Status comparison is case-insensitive; entries with a missing/blank
// status are excluded (we only auto-bind when the BE clearly considers
// the row live).
export function pickActiveTreatments(lead) {
    const list = Array.isArray(lead?.lead_treatments) ? lead.lead_treatments : [];
    return list.filter((t) => {
        const status = (t?.status || '').toUpperCase();
        return status && status !== 'CLOSED' && status !== 'ARCHIVED';
    });
}

// Returns the only active treatment when the auto-bind branch should fire
// (exactly one active), otherwise null. Used by the slideout's
// open-effect so the call site stays readable.
export function getAutoBindTreatment(lead) {
    const active = pickActiveTreatments(lead);
    return active.length === 1 ? active[0] : null;
}
